export const ALLOWED_LATE_SUBMITS = new Set(['none']);

export const HYPERDRIVE = {
  name: 'Hyperdrive',
  description: 'The Solana Hyperdrive hackathon',
  start_date: new Date('2023-09-06T00:00:00.000Z'),
  end_date: new Date('2023-10-15T00:00:00.000Z'),
};

export const ENGINEERING_ROLES = new Set([
  'Software Engineer',
  'Backend Developer',
  'Frontend Developer',
  'Protocol Engineer',
  'AI / ML Engineer',
  'Data Scientist',
  'Game Developer',
  'Mobile Developer',
  'Systems Engineer',
  'Hardware Engineer',
]);

export const ROLES = [
  ...ENGINEERING_ROLES,
  'Product Designer',
  'Visual Designer',
  'Biz Dev',
  'Community Manager',
  'Content Creator',
  'Finance & Ops',
  'Lawyer',
  'Marketer',
  'Product Manager',
];

export const SKILLS = [
  'Anchor',
  'APIs / Backend Web',
  'Embedded Systems',
  'C',
  'C++',
  'DevOps',
  'Data Pipelines',
  'Cryptography',
  'UIs / Frontend Web',
  'Golang',
  'GraphQL',
  'Java',
  'NoSQL DBs',
  'SQL DBs',
  'Python',
  'React Native',
  'iOS Mobile',
  'Android Mobile',
  'Ruby',
  'Rust',
  'Smart Contracts',
  'Solidity',
  'Typescript',
  'PHP',
  'Unity',
  'Unreal Engine',
  'Financial Engineering',
  'LLMs / Neural Networks',
];

export const HYPERDRIVE_TRACKS = [
  'Physical Infrastructure Networks',
  'Artificial Intelligence',
  'Finance & Payments',
  'Games & Entertainment',
  'Mobile Consumer Apps',
  'Crypto Infrastructure',
  'DAOs & Network States',
];

export const RENAISSANCE_TRACKS = [
  'DePin',
  'DeFi & Payments',
  'DAOs & Communities',
  'Consumer Apps',
  'Gaming',
  'Infrastructure',
];

export const RADAR_TRACKS = [
  'DePIN',
  'DeFi',
  'DAOs & Network States',
  'Payments',
  'Consumer',
  'Gaming',
  'Infrastructure',
];

export const USE_CASES = [
  'DePIN',
  'DeFi',
  'Payments',
  'Gaming',
  'Social',
  'Developer Infrastructure',
  'Security Tools',
  'Community DAOs',
  'Consumer / Other',
];

// taken from https://gist.githubusercontent.com/matthlavacka/de1e71ff9c67c114e2146c08def0581b/raw/aa35dd5f202c0d477c0fe6b65e4c3c9b3ee223a5/languages.json
export const LANGUAGES = {
  en: {
    name: 'English',
    speakers: 765000000,
  },
  af: {
    name: 'Afrikaans',
    speakers: 15200000,
  },
  am: {
    name: 'Amharic',
    speakers: 25800000,
  },
  sq: {
    name: 'Albanian',
    speakers: 7500000,
  },
  ar: {
    name: 'Arabic',
    speakers: 425000000,
  },
  hy: {
    name: 'Armenian',
    speakers: 6400000,
  },
  az: {
    name: 'Azerbaijani',
    speakers: 28000000,
  },
  eu: {
    name: 'Basque',
    speakers: 720000,
  },
  be: {
    name: 'Belarusian',
    speakers: 8600000,
  },
  bn: {
    name: 'Bengali',
    speakers: 250000000,
  },
  bs: {
    name: 'Bosnian',
    speakers: 3500000,
  },
  bg: {
    name: 'Bulgarian',
    speakers: 9100000,
  },
  ca: {
    name: 'Catalan',
    speakers: 11500000,
  },
  ceb: {
    name: 'Cebuano',
    speakers: 21000000,
  },
  ny: {
    name: 'Chichewa',
    speakers: 12000000,
  },
  zh: {
    name: 'Chinese',
    speakers: 1026000000,
  },
  co: {
    name: 'Corsican',
    speakers: 200000,
  },
  hr: {
    name: 'Croatian',
    speakers: 16000000,
  },
  cs: {
    name: 'Czech',
    speakers: 9500000,
  },
  da: {
    name: 'Danish',
    speakers: 5600000,
  },
  nl: {
    name: 'Dutch',
    speakers: 22000000,
  },
  sjn: {
    name: 'Elvish',
    speakers: 1200000,
  },
  eo: {
    name: 'Esperanto',
    speakers: 2000000,
  },
  et: {
    name: 'Estonian',
    speakers: 1200000,
  },
  tl: {
    name: 'Filipino',
    speakers: 25000000,
  },
  fo: {
    name: 'Faroese',
    speakers: null,
  },
  farsi: {
    name: 'Farsi',
    speakers: 56600000,
  },
  fj: {
    name: 'Fijian',
    speakers: 5000000,
  },
  fi: {
    name: 'Finnish',
    speakers: 5000000,
  },
  fr: {
    name: 'French',
    speakers: 68500000,
  },
  fy: {
    name: 'Frisian',
    speakers: 470000,
  },
  gl: {
    name: 'Galician',
    speakers: 2400000,
  },
  ka: {
    name: 'Georgian',
    speakers: 4300000,
  },
  de: {
    name: 'German',
    speakers: 111800000,
  },
  el: {
    name: 'Greek',
    speakers: 13000000,
  },
  gu: {
    name: 'Gujarati',
    speakers: 46600000,
  },
  haw: {
    name: 'Hawaiian',
    speakers: 2000,
  },
  ht: {
    name: 'Haitian Creole',
    speakers: 7700000,
  },
  ha: {
    name: 'Hausa',
    speakers: 40000000,
  },
  he: {
    name: 'Hebrew',
    speakers: 5300000,
  },
  hi: {
    name: 'Hindi',
    speakers: 12500000,
  },
  hmn: {
    name: 'Hmong',
    speakers: 4000000,
  },
  hu: {
    name: 'Hungarian',
    speakers: 12500000,
  },
  is: {
    name: 'Icelandic',
    speakers: 330000,
  },
  ig: {
    name: 'Igbo',
    speakers: 18000000,
  },
  id: {
    name: 'Indonesian',
    speakers: 23000000,
  },
  iu: {
    name: 'Inuktitut',
    speakers: 34000,
  },
  iku: {
    name: 'Inuinnaqtun',
    speakers: 410,
  },
  ga: {
    name: 'Irish',
    speakers: 1000000,
  },
  it: {
    name: 'Italian',
    speakers: 61100000,
  },
  ja: {
    name: 'Japanese',
    speakers: 123000000,
  },
  jw: {
    name: 'Javanese',
    speakers: 84300000,
  },
  kk: {
    name: 'qazaq tili',
    speakers: 11000000,
  },
  kn: {
    name: 'Kannada',
    speakers: 46700000,
  },
  km: {
    name: 'Khmer',
    speakers: 16000000,
  },
  ko: {
    name: 'Korean',
    speakers: 66400000,
  },
  kok: {
    name: 'Konkani',
    speakers: 7400000,
  },
  ky: {
    name: 'Кyrgyz',
    speakers: 4300000,
  },
  ku: {
    name: 'Kurdish',
    speakers: 30000000,
  },
  ckb: {
    name: 'Central Kurdish',
    speakers: 7250000,
  },
  sdh: {
    name: 'Southern Kurdish',
    speakers: 5390000,
  },
  lo: {
    name: 'Lao',
    speakers: 20000000,
  },
  lv: {
    name: 'Latvian',
    speakers: 1700000,
  },
  lt: {
    name: 'Lithuanian',
    speakers: 3000000,
  },
  lb: {
    name: 'Luxembourgish',
    speakers: 390000,
  },
  mk: {
    name: 'Macedonian',
    speakers: 2500000,
  },
  mg: {
    name: 'Malagasy',
    speakers: 18000000,
  },
  ms: {
    name: 'Malay',
    speakers: 59400000,
  },
  ml: {
    name: 'Malayalam',
    speakers: 38000000,
  },
  mt: {
    name: 'Maltese',
    speakers: 520000,
  },
  mr: {
    name: 'Marathi',
    speakers: 71800000,
  },
  mn: {
    name: 'Mongolian',
    speakers: 5700000,
  },
  mi: {
    name: 'Māori',
    speakers: 60000,
  },
  my: {
    name: 'Burmese',
    speakers: 42900000,
  },
  ne: {
    name: 'Nepali',
    speakers: 14000000,
  },
  no: {
    name: 'Norwegian',
    speakers: 5000000,
  },
  pap: {
    name: 'Papiamento',
    speakers: 260000,
  },
  fa: {
    name: 'Persian',
    speakers: 56600000,
  },
  pl: {
    name: 'Polish',
    speakers: 39000000,
  },
  pt: {
    name: 'Portuguese',
    speakers: 217000000,
  },
  pa: {
    name: 'Punjabi',
    speakers: 29500000,
  },
  ps: {
    name: 'Pashto',
    speakers: 60000000,
  },
  otq: {
    name: 'Hñohño',
    speakers: 260000,
  },
  ro: {
    name: 'Romanian',
    speakers: 23000000,
  },
  ru: {
    name: 'Russian',
    speakers: 272000000,
  },
  sm: {
    name: 'Samoan',
    speakers: 510000,
  },
  gd: {
    name: 'Scottish Gaelic',
    speakers: 87000,
  },
  sr: {
    name: 'Serbian',
    speakers: 16000000,
  },
  'sr-LA': {
    name: 'Serbian',
    speakers: 16000000,
  },
  sd: {
    name: 'Sindhi',
    speakers: 75000000,
  },
  si: {
    name: 'Sinhalese',
    speakers: 16000000,
  },
  sk: {
    name: 'Slovak',
    speakers: 5000000,
  },
  sl: {
    name: 'Slovenian',
    speakers: 2500000,
  },
  sn: {
    name: 'Slovenian',
    speakers: 2500000,
  },
  st: {
    name: 'Sotho',
    speakers: 5600000,
  },
  so: {
    name: 'Somali',
    speakers: 14000000,
  },
  es: {
    name: 'Spanish',
    speakers: 466000000,
  },
  su: {
    name: 'Sundanese',
    speakers: 38000000,
  },
  sw: {
    name: 'Swahili',
    speakers: 140000000,
  },
  sv: {
    name: 'Swedish',
    speakers: 8300000,
  },
  ty: {
    name: 'Tahitian',
    speakers: 68000,
  },
  ta: {
    name: 'Tamil',
    speakers: 76800000,
  },
  tg: {
    name: 'Tajik',
    speakers: 8400000,
  },
  te: {
    name: 'Telugu',
    speakers: 79000000,
  },
  th: {
    name: 'Thai',
    speakers: 60000000,
  },
  bo: {
    name: 'Tibetan',
    speakers: 1200000,
  },
  to: {
    name: 'Tongan',
    speakers: 96000,
  },
  tr: {
    name: 'Turkish',
    speakers: 50700000,
  },
  uk: {
    name: 'Ukrainian',
    speakers: 36000000,
  },
  ur: {
    name: 'Urdu',
    speakers: 63400000,
  },
  uz: {
    name: 'Uzbek',
    speakers: 27000000,
  },
  vi: {
    name: 'Vietnamese',
    speakers: 67800000,
  },
  cy: {
    name: 'Welsh',
    speakers: 740000,
  },
  xh: {
    name: 'Xhosa',
    speakers: 8200000,
  },
  yi: {
    name: 'Yiddish',
    speakers: 1500000,
  },
  yo: {
    name: 'Yoruba',
    speakers: 21000000,
  },
  yua: {
    name: 'Yucatec Maya',
    speakers: 790000,
  },
  yue: {
    name: 'Yueh',
    speakers: 60000000,
  },
  zu: {
    name: 'Zulu',
    speakers: 26000000,
  },
};

// taken from https://gist.github.com/kalinchernev/486393efcca01623b18d
export const COUNTRIES = [
  'United States',
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua & Deps',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Central African Rep',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo {Democratic Rep}',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland {Republic}',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea North',
  'Korea South',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar, {Burma}',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'St Kitts & Nevis',
  'St Lucia',
  'Saint Vincent & the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome & Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Eswatini',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tonga',
  'Trinidad & Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

export const RENAISSANCE_SUBMISSION_COUNTRIES = [
  'Andorra',
  'Antigua & Deps',
  'Argentina',
  'Australia',
  'Bangladesh',
  'Belgium',
  'Brazil',
  'Bulgaria',
  'Canada',
  'China',
  'Colombia',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Egypt',
  'Finland',
  'France',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Guatemala',
  'Hong Kong',
  'Hungary',
  'India',
  'Indonesia',
  'Iran',
  'Ireland {Republic}',
  'Israel',
  'Italy',
  'Japan',
  'Kazakhstan',
  'Kenya',
  'Korea South',
  'Kosovo',
  'Lithuania',
  'Malaysia',
  'Mexico',
  'Montenegro',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nigeria',
  'Norway',
  'Pakistan',
  'Philippines',
  'Poland',
  'Portugal',
  'Russian Federation',
  'Serbia',
  'Sierra Leone',
  'Singapore',
  'South Africa',
  'Spain',
  'Sweden',
  'Switzerland',
  'Taiwan',
  'Tanzania',
  'Thailand',
  'Tunisia',
  'Turkey',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Vietnam',
];

export const SOLANA_INITIATIVES = [
  'SolanaU',
  'Solana Collective',
  'Superteam',
  'Solana Hacker Houses',
  'Community Hacker Houses (mtnDAO, etc.)',
  'None of the above',
];

export const RENAISSANCE_MARKETING_CHANNELS = [
  'Colosseum social media',
  'Solana Foundation social media',
  'Ecosystem company social media',
  'Ecosystem organizations (Superteam, mtndao, Solana University, etc.)',
  'Word of mouth',
  "I've participated in a previous hackathon",
  'Other',
  'None of the above',
];

export const RENAISSANCE_ORG_INITIATIVES = [
  'Superteam',
  'mtnDAO',
  'Solana University',
  'WBA / Solana Turbine',
  'Solana Hacker House',
  'Gen3',
  'Christex Foundation',
  'Deanslist DAO',
  'Other',
];

export const RADAR_SUPPORTING_GROUPS = [
  'Superteam',
  'mtnDAO',
  'IslandDAO',
  'Solana University',
  'WBA / Solana Turbine',
  'Solana Hacker House',
  'Gen3',
  'Christex Foundation',
  'Deanslist DAO',
  'Solar',
  'Kumeka Team',
  'La Familia',
  'Co-Hack',
  'Other',
];

export const SOLANA_FOUNDATION_CONTACT_TOPICS = [
  'Solana community news',
  'Developer resources and updates',
  'Future Solana hackathons or builder events',
  'In-person events, such as Breakpoint 2025',
];

export const MARKETING_CHANNELS = [
  'Word of mouth (Coworker, friend, etc.)',
  'Twitter',
  'YouTube',
  'Solana.com',
  'Hacker House',
  'Other',
];

export const hackathonDeadline = new Date(Date.UTC(2024, 3, 30, 8, 0, 0));
export const localStorageExpiry = 7 * 24 * 60 * 60 * 1000; // 7 days expiry
export const projectFilesLocalStorageKey = 'project-submission-media-files';
export const projectFormLocalStorageKey = 'project-submission-form';
export const projectTeamMembersLocalStorageKey =
  'project-submission-team-members';

export enum PostCategory {
  PRODUCT_IDEAS = 'Product Ideas',
  LOOKING_FOR_TEAM = 'Looking for Team',
  HACKATHON_TALK = 'Hackathon Talk',
  TECHNICAL_QUESTIONS = 'Technical Questions',
}

export const POST_CATEGORIES: PostCategory[] = [
  PostCategory.PRODUCT_IDEAS,
  PostCategory.LOOKING_FOR_TEAM,
  PostCategory.HACKATHON_TALK,
  PostCategory.TECHNICAL_QUESTIONS,
];

export const ACTIVE_POST_CATEGORIES = [
  PostCategory.PRODUCT_IDEAS,
  PostCategory.LOOKING_FOR_TEAM,
];
